
export default {
  name: 'OrganismAnchorsV2',
  props: {
    anchors: {
      required: true,
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      instance: null,
      options: {
        perPage: 7,
        pagination: false,
        autoWidth : true,
        padding: '3.375rem',
        arrows: true,
        drag: false,
        breakpoints: {
          1200: {
            perPage: 4,
            drag: true
          },
          900: {
            perPage: 2,
            padding: '2rem',
            drag: true
          },
          767: {
            perPage: 1,
            drag: true
          }
        }
      }
    }
  }
}
